import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js"
import javascript from "highlight.js/lib/languages/javascript"
import xml from "highlight.js/lib/languages/xml"

hljs.registerLanguage("javascript", javascript)
hljs.registerLanguage("xml", xml)

export default class extends Controller {
  connect() {
    this.highlightCode()
  }

  highlightCode() {
    hljs.highlightElement(this.element)
  }
}
